module.exports = __webpack_public_path__ + "assets/img/MCM.d1e73d20.png";